module.exports = __webpack_public_path__ + "static/media/vibe-outline.0fb05e99.svg";